import SimpleDialog from '@fuse/core/SimpleDialog';
import StaffContactDetails from 'app/shared-components/StaffContactDetails';
import { useState } from 'react';
import TopBirthdayCard from './TopBirthdayCard';

const TopsBirthdayList = ({ birthdays, isToday }) => {
  const [activeEmplId, setActiveEmplId] = useState(null);
  return (
    <>
      <div className="space-y-20">
        {birthdays.map((birthday) => (
          <TopBirthdayCard
            key={birthday.id}
            {...birthday}
            isToday={isToday}
            setActiveEmplId={setActiveEmplId}
          />
        ))}
      </div>
      <SimpleDialog open={!!activeEmplId} onClose={() => setActiveEmplId(null)} noPadding>
        <StaffContactDetails id={activeEmplId} />
      </SimpleDialog>
    </>
  );
};

export default TopsBirthdayList;
